function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLowVolume = function SvgLowVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "400pt",
    height: "400pt",
    viewBox: "0 0 75 75"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M39.389 13.769 22.235 28.606H6v19.093h15.989l17.4 15.051z",
    style: {
      stroke: "#111",
      strokeWidth: 5,
      strokeLinejoin: "round",
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.128 49.03a20.087 20.087 0 0 0-.085-21.453",
    style: {
      fill: "none",
      stroke: "#111",
      strokeWidth: 5,
      strokeLinecap: "round"
    }
  }));
};
export { SvgLowVolume as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgp4bWxuczpjYz0iaHR0cDovL3dlYi5yZXNvdXJjZS5vcmcvY2MvIgp4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCnhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCnhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKeG1sOnNwYWNlPSJwcmVzZXJ2ZSIKdmVyc2lvbj0iMS4wIgppZD0ibGF5ZXIxIgp3aWR0aD0iNDAwcHQiIGhlaWdodD0iNDAwcHQiCnZpZXdCb3g9IjAgMCA3NSA3NSI+PG1ldGFkYXRhCmlkPSJtZXRhZGF0YTEiPjxyZGY6UkRGPjxjYzpXb3JrCnJkZjphYm91dD0iIj48ZGM6Zm9ybWF0PmltYWdlL3N2Zyt4bWw8L2RjOmZvcm1hdD48ZGM6dHlwZQpyZGY6cmVzb3VyY2U9Imh0dHA6Ly9wdXJsLm9yZy9kYy9kY21pdHlwZS9TdGlsbEltYWdlIiAvPjwvY2M6V29yaz48L3JkZjpSREY+PC9tZXRhZGF0YT48ZwppZD0iZzEiPjxwb2x5Z29uCmlkPSJwb2x5Z29uMSIKcG9pbnRzPSIzOS4zODksMTMuNzY5IDIyLjIzNSwyOC42MDYgNiwyOC42MDYgNiw0Ny42OTkgMjEuOTg5LDQ3LjY5OSAzOS4zODksNjIuNzUgMzkuMzg5LDEzLjc2OSIKc3R5bGU9InN0cm9rZTojMTExMTExO3N0cm9rZS13aWR0aDo1O3N0cm9rZS1saW5lam9pbjpyb3VuZDtmaWxsOiMxMTExMTE7IgovPjxwYXRoIGlkPSJwYXRoMSIKZD0iTSA0OC4xMjgsNDkuMDMgQyA1MC4wNTcsNDUuOTM0IDUxLjE5LDQyLjI5MSA1MS4xOSwzOC4zNzcgQyA1MS4xOSwzNC4zOTkgNTAuMDI2LDMwLjcwMyA0OC4wNDMsMjcuNTc3IgpzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMTExMTExO3N0cm9rZS13aWR0aDo1O3N0cm9rZS1saW5lY2FwOnJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==";